import { render } from "./PatientListPage.vue?vue&type=template&id=81d5e78e&ts=true"
import script from "./PatientListPage.vue?vue&type=script&lang=ts"
export * from "./PatientListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Patient/PatientListPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81d5e78e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81d5e78e', __exports__)) {
    api.reload('81d5e78e', __exports__)
  }
  
  module.hot.accept("./PatientListPage.vue?vue&type=template&id=81d5e78e&ts=true", () => {
    api.rerender('81d5e78e', render)
  })

}


export default __exports__